import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const error = params.get('error');
    if (error) { navigate('/login?error=oauth_failed', { replace: true }); return; }
    const token = 'cookie-session';
    window.history.replaceState({}, '', '/auth/callback');
    localStorage.setItem('adeeb-token', token);
    localStorage.setItem('adeeb-session-mode', 'parent'); // OAuth = parent flow
    axios
      .get('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => {
        if (data?.user) localStorage.setItem('adeeb-user', JSON.stringify(data.user));
      })
      .then(() => {
        window.dispatchEvent(new Event('adeeb-auth-change'));
        navigate('/profiles/select', { replace: true });
      }).catch(() => { localStorage.removeItem('adeeb-token'); navigate('/login?error=oauth_failed', { replace: true }); });
  }, [params, navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', color: '#daa520', fontFamily: 'Cormorant Garamond, serif' }}>
      Signing you in…
    </div>
  );
}
